export enum IncentiveType {
  FOMO = "fomo",
  VOUCHERS = "vouchers"
}
